import { useAppDispatch, useAppSelector } from '../index';
import { fetchCurrentCustomer, updateCurrentCustomerProfile } from '@ogsnetwork/opp-redux-lib';
import { useCallback, useEffect } from 'react';
import { combineValidationErrors, useStateWithValidation } from '../validation';
import { validateUsername } from './validation';
const REFRESH_INTERVAL_MILLISECONDS = 60000 * 5;
export function useCustomer(props) {
    const dispatch = useAppDispatch();
    const authentication = useAppSelector((state) => state.authentication);
    const customer = useAppSelector((state) => state.customer.customer);
    function refreshCustomer() {
        dispatch(fetchCurrentCustomer());
    }
    useEffect(() => {
        let refreshInterval;
        if ((props === null || props === void 0 ? void 0 : props.customerRefreshEnabled) &&
            (authentication.status === 'loggedIn' || authentication.status === 'success')) {
            refreshInterval = setInterval(() => refreshCustomer(), REFRESH_INTERVAL_MILLISECONDS);
        }
        return () => {
            if (refreshInterval) {
                clearInterval(refreshInterval);
            }
        };
    }, [authentication.status]);
    return {
        customer,
        refreshCustomer
    };
}
export function useUpdateCustomerProfile() {
    var _a, _b;
    const dispatch = useAppDispatch();
    const customer = useAppSelector((state) => state.customer);
    const username = useStateWithValidation(validateUsername, (_b = (_a = customer.customer) === null || _a === void 0 ? void 0 : _a.user.username) !== null && _b !== void 0 ? _b : '');
    const isValid = username.isValid && !username.isPristine;
    const validationErrors = combineValidationErrors(username.errors);
    const dispatchUpdateProfile = useCallback(() => {
        if (isValid) {
            dispatch(updateCurrentCustomerProfile({ username: username.value }));
        }
    }, [username.value, isValid]);
    useEffect(() => {
        var _a;
        if (username.value === ((_a = customer.customer) === null || _a === void 0 ? void 0 : _a.user.username)) {
            username.reset();
        }
    }, [username.value]);
    useEffect(() => {
        if (customer.status === 'success') {
            username.reset();
        }
    }, [customer.status]);
    return {
        username: username.value,
        status: customer.status,
        setUsername: username.setValue,
        dispatchUpdateProfile,
        error: validationErrors !== null && validationErrors !== void 0 ? validationErrors : customer.error,
        isValid
    };
}
